import { render, staticRenderFns } from "./TenantEditDetailsTab.vue?vue&type=template&id=49561d2a"
import script from "./TenantEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./TenantEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports